<template lang="html">
    <div class="motor-details">

        <PageTitle
            :text="pageTitle"
            :breadcrumb="pageTitle"
            :parent="{
                text: 'Ma sélection',
                path: '/selection'
        }">
        </PageTitle>

        <div class="layout-width padding" v-if="userSite">

            <div
                class="padding shadow"
                style="margin: 20px 0;">
                <el-form
                    ref="formDetail"
                    :model="form"
                    :rules="rules"
                    label-width="150px">
                    <el-row>
                        <el-form-item
                            label="Puissance (kW)"
                            prop="detail_pn">
                            <el-col
                                :xs="22"
                                :sm="8">
                                <el-input-number
                                    v-model.number="form.detail_pn"
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp text="Puissance nominale plaquée pression machine entrainée"></FormHelp>
                            </el-col>
                        </el-form-item>

                        <el-form-item
                            label="Un (Volt)"
                            prop="detail_un">
                            <el-col
                                :xs="22"
                                :sm="8">
                                <el-input-number
                                    v-model="form.detail_un"
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp text="Tension nominale plaquée"></FormHelp>
                            </el-col>
                            <el-col
                                :xs="24"
                                :sm="14"
                            >
                                <el-button @click="form.detail_un = 380" size="small" >380 Volts</el-button>
                                <el-button @click="form.detail_un = 400" size="small" >400 Volts</el-button>
                                <!-- Commenter car sur viveco il est spécifier que la tension ne peux pas dépasser 400 volt -->
<!--                                 <el-button @click="form.detail_un = 600" size="small" >600 Volts</el-button> -->
                            </el-col>
                        </el-form-item>

                        <el-form-item
                            label="In (Amp)"
                            prop="detail_in">
                            <el-col
                                :xs="22"
                                :sm="8">
                                <el-input-number
                                    v-model.number="form.detail_in"
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp text="Courant nominale plaquée"></FormHelp>
                            </el-col>
                        </el-form-item>

                        <el-form-item
                            label="Moteur cos phi"
                            prop="detail_cosphi">
                            <el-col
                                :xs="22"
                                :sm="8">
                                <el-input-number
                                    v-model.number="form.detail_cosphi"
                                    :min="0.6"
                                    :max="0.9"
                                    :step="0.01"
                                    style="width:100%">
                                </el-input-number>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp text="Moteur cos phi"></FormHelp>
                            </el-col>
                        </el-form-item>

                        <el-form-item
                            label="Vitesse de rotation"
                            prop="detail_speed">
                            <el-col
                                class="large-text"
                                :xs="22"
                                :sm="8">
                                <el-input-number
                                    v-model.number="form.detail_speed"
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-col>
                            <el-col
                                :span="2">
                                <FormHelp text="Vitesse de rotation nominale plaquée"></FormHelp>
                            </el-col>
                        </el-form-item>


                        <el-form-item
                            label="Type de carcasse"
                            prop="casing_type">
                            <el-col :span="12">
                                <el-select
                                    v-model="form.casing_type"
                                    placeholder="Sélectioner un type de structure"
                                    style="width:100%">
                                    <el-option
                                        v-for="(casing, index) in casingTypes"
                                        :key="index"
                                        :label="casing.label"
                                        :value="casing.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col
                                :span="2">
                                <FormHelp text="Type de carcasse"></FormHelp>
                            </el-col>
                        </el-form-item>

                        <el-form-item
                            label="Application"
                            prop="application_uid">
                            <el-col :span="12">
                                <el-select
                                    v-model="form.application_uid"
                                    placeholder="Sélectioner une application"
                                    style="width:100%">
                                    <el-option
                                        v-for="o in orderedMotorApplication"
                                        :key="o.uid"
                                        :label="o.label"
                                        :value="o.uid">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp
                                    text="Type de machine entrainée">
                                </FormHelp>
                            </el-col>
                        </el-form-item>

                        <el-form-item
                            label="Régulation"
                            prop="detail_regulation_uid">
                            <el-col :span="12">
                                <el-select
                                    v-model="form.detail_regulation_uid"
                                    placeholder="Sélectioner une régulation"
                                    style="width:100%">
                                    <el-option
                                        v-for="o in orderedMotorRegulationDetail"
                                        :key="o.uid"
                                        :label="o.label"
                                        :value="o.uid">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp text="Type de régulation"></FormHelp>
                            </el-col>
                        </el-form-item>

                        <h2><strong>Machine entrainée</strong></h2>
                        <br>
                        <el-radio-group
                            v-model="displayPower"
                            style="margin-bottom: 15px; margin-left:100px;"
                        >
                            <el-radio-button :label="true">Renseigner puissance</el-radio-button>
                            <el-radio-button :label="false">Renseigner pression, débit, rendement</el-radio-button>
                        </el-radio-group>
                        <el-form-item
                            v-if="displayPower"
                            label="Puissance (kW)"
                            prop="power">
                            <el-col :span="8">
                                <el-input-number
                                    v-model="form.power"
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp
                                    text="Puissance nominale plaquée machine entrainée">
                                </FormHelp>
                            </el-col>
                        </el-form-item>

                        <template v-else>
                            <el-row :gutter="0">
                                <el-col :span="14">
                                    <el-form-item
                                        label="Pression"
                                        prop="pressure">
                                        <el-col :span="20">
                                            <el-input-number
                                                v-model="form.pressure"
                                                :min="0"
                                                style="width:100%">
                                            </el-input-number>
                                        </el-col>
                                        <el-col :span="4">
                                            <FormHelp
                                                text="Pression nominale plaquée machine entrainée">
                                            </FormHelp>
                                        </el-col>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="10">
                                    <el-form-item
                                        label="Unité de pression"
                                        prop="selectedPresureUnit"
                                    >
                                        <el-select
                                            v-model="form.selectedPresureUnit"
                                            placeholder="Unité pression machine entrainée"
                                            style="width:100%">
                                            <el-option
                                                v-for="(o, i) in pressureUnits"
                                                :key="i"
                                                :label="o"
                                                :value="o">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row :gutter="0">
                                <el-col :span="14">
                                    <el-form-item
                                        label="Débit"
                                        prop="flow">
                                        <el-col :span="20">
                                            <el-input-number
                                                v-model="form.flow"
                                                :min="0"
                                                style="width:100%">
                                            </el-input-number>
                                        </el-col>
                                        <el-col :span="4">
                                            <FormHelp
                                                text="Débit nominale plaquée machine entrainée">
                                            </FormHelp>
                                        </el-col>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="10">
                                    <el-form-item
                                        label="Unité de débit"
                                        prop="selectedFlowUnit">
                                        <el-select
                                            v-model="form.selectedFlowUnit"
                                            placeholder="Unité débit nominale plaquée machine entrainée"
                                            style="width:100%">
                                            <el-option
                                                v-for="(o, i) in flowUnits"
                                                :key="i"
                                                :label="o"
                                                :value="o">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item
                                label="Rendement"
                                prop="efficiency">
                                <el-col :span="8">
                                    <el-input-number
                                        v-model="form.efficiency"
                                        :min="0"
                                        :max="1"
                                        style="width:100%">
                                    </el-input-number>
                                </el-col>
                                <el-col :span="2">
                                    <FormHelp
                                        text="Rendement machine entrainée. Doit être compris entre 0 et 1">
                                    </FormHelp>
                                </el-col>
                            </el-form-item>
                        </template>

                        <el-form-item
                            label="Durée de fonctionnement (h/an)"
                            prop="annual_working_time">
                            <el-col :span="12">
                                <el-input v-model.number="form.annual_working_time" type="number"></el-input>
                            </el-col>
                            <el-col :span="2">
                                <FormHelp text="La valeur correspondant à une année entière serait 8760"></FormHelp>
                            </el-col>
                        </el-form-item>

                        <el-form-item>
                            <el-button
                                type="primary"
                                icon="el-icon-check"
                                @click="save">
                                Enregistrer
                            </el-button>
                            <el-button
                                icon="el-icon-close"
                                @click="$router.go(-1)">
                                Annuler
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
import PageTitle from '@/components/partials/ui/PageTitle';
import FormHelp from '../../partials/ui/FormHelp';
import { mapGetters } from 'vuex';
import schwartz from 'schwartz';
export default {
    name: 'MotorDetails',
    components: {
        PageTitle,
        FormHelp
    },
    watch:{
        'form.application_uid' (val){
            if (val !== this.currentMotor.application_uid){
                this.form.detail_regulation_uid = ''
            }else{
                this.form.detail_regulation_uid = this.currentMotor.detail_regulation_uid
            }
        }
    },
    data () {
        let detailUnValidate = (rule, value, callback) => {
            if(value < 380 || value > 400){
                callback(new Error('Veuillez choisir un nombre entre 380 et 400.'));
            }else{
                callback();
            }
        };
        let cosphiValidate = (rule, value, callback) => {
            if(value < 0 || value > 1){
                callback(new Error('Veuillez choisir un chiffre entre 0 et 1.'));
            }else{
                callback();
            }
        };
        let validateAnnualWorking = (rule, value, callback) => {
            if(value === ''){
                return callback(new Error('Veuillez choisir une durée de fonctionnement.'));
            }
            if(isNaN(value)) {
                return callback(new Error('Veuillez choisir un chiffre valide'));
            }
            if(value <= 0) {
                return callback(new Error('Veuillez choisir un chiffre supèrieur à 0.'));
            }
            callback();
        };
        let detailInValidate = (rule, value, callback) => {
            if(value < 3 || value > 2000){
                callback(new Error('Veuillez choisir un nombre entre 3 et 2000.'));
            }else{
                callback();
            }
        };

        let detailPnValidate = (rule, value, callback) => {
            if(value <= 0){
                callback(new Error('Veuillez choisir un chiffre supèrieur à 0.'));
            }else{
                callback();
            }
        };

        let detailSpeedValidate = (rule, value, callback) => {
            let errorMsg = 'Les valeurs possibles doivent être comprise entre 1400 et 1500 tr/min ou 2900 et 3000 tr/min';
            if(value === 750 || value === 1000){
                callback();
            }
            else if((value >= 1400 && value <= 1500) || (value >= 2900) && value <= 3000){
                callback();
            }else{
                callback(new Error(errorMsg));
            }
        };
        let efficiencyValidation = (rule, value, callback) =>{
            if(value < 0 || value > 1){
                callback(new Error('Le rendement doit être compris entre 0 et 1'));
            }else{
                callback();
            }
        };
        return {
            displayPower: true,
            form: {
                power: '',
                flow: '',
                selectedFlowUnit: '',
                selectedPresureUnit: '',
                efficiency: '',
                pressure: '',
                detail_pn: null,
                detail_un: null,
                detail_in: null,
                detail_cosphi: null,
                detail_speed: null,
                detail_regulation_uid: '',
                casing_type: '',
                annual_working_time: '',
            },
            pressureUnits: ['bar', 'Pa', 'mCe'],
            flowUnits: ['m3/s', 'm3/min', 'm3/h'],
            rules: {
                detail_pn: [
                    {type: 'number', required: true, message: 'Veuillez choisir un chiffre supèrieur à 0.'},
                    {validator: detailPnValidate},
                ],
                annual_working_time: [
                    {type: 'number', required: true, message: 'Veuillez choisir un chiffre supèrieur à 0.'},
                    {validator: validateAnnualWorking},
                ],
                detail_un: [
                    {required: true, message: 'Veuillez choisir un nombre entre 380 et 400.'},
                    {validator: detailUnValidate},
                ],
                detail_in: [
                    {type: 'number', required: true, message: 'Veuillez choisir un nombre entre 3 et 2000.'},
                    {validator: detailInValidate},
                ],
                detail_cosphi: [
                    {required: true, message: 'Veuillez choisir un chiffre entre 0 et 1'},
                    {validator: cosphiValidate},
                ],
                detail_speed: [
                    {type: 'number', required: true, message: 'Les valeurs possibles doivent être comprise entre 1400 et 1500 tr/min ou 2900 et 3000 tr/min, ou égale à 750 ou 1000 tr/min.'},
                    {validator: detailSpeedValidate}
                ],
                detail_regulation_uid: [
                    {required: true, message: 'Veuillez sélectionner une régulation.'}
                ],
                casing_type: [
                    {required: true, message: 'Veuillez sélectionner un type de carcasse.'}
                ],
                power: [
                    { required: true, message: 'La puissance est un champs obligatoire', trigger: 'blur' }
                ],
                selectedPresureUnit: [
                    { required: true, message: 'L\'unité de pression est un champs obligatoire', trigger: 'blur' }
                ],
                selectedFlowUnit: [
                    { required: true, message: 'L\'unité de débit est un champs obligatoire', trigger: 'blur' }
                ],
                pressure: [
                    { required: true, message: 'Pression est un champs obligatoire', trigger: 'change' }
                ],
                flow: [
                    { required: true, message: 'Débit est un champs obligatoire', trigger: 'change' }
                ],
                efficiency: [
                    { required: true, message: 'Rendement est un champs obligatoire', trigger: 'change' },
                    {validator: efficiencyValidation}
                ],
            },

            scopedRegulations: {
                centrifugal_ventilation: [
                    'drawing_beforehand_with_registers',
                    'drawing_afterwards_with_registers',
                    'drawing_beforehand_with_valves',
                    'electronic_speed_variation',
                    'no_adjustment'
                ],
                axial_ventilation: [
                    'blades_with_self_adjusting_interval',
                    'drawing_afterwards',
                    'electronic_speed_variation',
                    'no_adjustment'
                ],
                motor: [
                    'no_adjustment'
                ],
                pumping: [
                    'by_pass',
                    'throttle_valve',
                    'coupler',
                    'all_or_none',
                    'electronic_speed_variation',
                    'no_adjustment'
                ]
            },
        };
    },
    computed: {
        ...mapGetters([
            'currentSite',
            'motorByUid',
            'motorApplicationByUid',
            'motorRegulationDetail',
            'motorRegulationDetailByUid',
            'motorApplication',
            'motorTechnologyByUid',
            'motorNeedByUid',
            'motorUsageByUid',
            'motorAgeByUid',
        ]),
        userSite () {
            if (this.currentSite){
                return this.currentSite
            }
            this.$router.push({name: 'Home'})
        },
        currentMotor () {
            return this.$route.params.motorUid
                ? this.motorByUid(this.$route.params.motorUid)
                : null;
        },
        pageTitle () {
            return 'Plaque moteur ' + this.currentMotor.name;
        },

        allowedMotorRegulationDetail (){
            let motorApplication = this.motorApplicationByUid(this.form.application_uid);
            let regulations = this.motorRegulationDetail.filter((mrd) => {
                if (this.scopedRegulations[motorApplication.verbose_label]) {
                    return this.scopedRegulations[motorApplication.verbose_label].includes(mrd.verbose_label);
                }
            });

            if (!regulations.length) {
                return this.motorRegulationDetail;
            }
            return regulations;
        },
        orderedMotorApplication() {
            return schwartz(this.motorApplication, (application) => application.display_order);
        },
        orderedMotorRegulationDetail () {
            return schwartz(this.allowedMotorRegulationDetail, (regulation) => regulation.display_order);
        },
        casingTypes() {
            return [
                {
                    label: '--------',
                    value: ''
                },
                {
                    label: 'Aluminium',
                    value: 'aluminium'
                },
                {
                    label: 'Fonte',
                    value: 'cast_iron'
                },
                {
                    label: 'ATEX',
                    value: 'atex'
                },
            ];
        },

        computePnMe() {
            let flow = this.form.trained_machine.flow;
            if (this.selectedFlowUnit === 'm³/s') {
                flow *= 3600;
            }
            else if (this.selectedFlowUnit === 'm³/min') {
                flow *= 60;
            }

            let pressure = this.form.trained_machine.pressure;
            if (this.selectedPresureUnit === 'bar') {
                pressure *= 10.19;
            }
            else if (this.selectedPresureUnit === 'Pa') {
                pressure *= 10.19 / Math.pow(1.10, 6);
            }
            let machinePnMe = flow * (pressure / (367 * this.form.trained_machine.efficiency));

            let locale = this.getLangage == 'fr' ? 'fr-FR' : 'en-EN';
            return new Intl.NumberFormat(locale, { style: 'decimal' }).format(machinePnMe.toFixed(3));
        }
    },
    created () {
        this.form = Object.assign({}, this.form, this.currentMotor);

        this.form.pressure = this.form.trained_machine.pressure;
        this.form.power = this.form.trained_machine.pn_me;
        this.form.flow = this.form.trained_machine.flow;
        this.form.efficiency = this.form.trained_machine.efficiency;
        this.form.selectedPresureUnit = this.form.trained_machine.pressure_unit;
        this.form.selectedFlowUnit = this.form.trained_machine.flow_unit;
    },
    methods: {
        save () {
            this.$refs.formDetail.validate((valid) => {
                if (valid) {
                    this.form.trained_machine.pressure = this.form.pressure;
                    this.form.trained_machine.flow = this.form.flow;
                    this.form.trained_machine.efficiency = this.form.efficiency;
                    this.form.trained_machine.pn_me = this.form.power;
                    this.form.trained_machine.flow_unit = this.form.selectedFlowUnit;
                    this.form.trained_machine.pressure_unit = this.form.selectedPresureUnit;

                    if(!this.displayPower){
                        this.form.trained_machine.pn_me = this.computePnMe;
                    }
                    const item = Object.assign({
                        uid: this.currentMotor.uid,
                        url: this.currentMotor.url
                    }, this.form);
                    delete item.measures_file;
                    // save in concrete
                    item.score = this.$store.getters.getScore(this);
                    if (item.score <= 0){
                        item.selected = false;
                    }
                    this.$store.dispatch('patchItem', {
                        item,
                        model: 'motor',
                        url: 'motor/'
                    // eslint-disable-next-line
                    }).then(res => {
                        this.$notify({
                            title: 'Enregistré',
                            message: 'Plaque moteur enregistrée avec succès',
                            type: 'success'
                        });
                        this.$router.push({ name: 'Selection' });
                    }).catch(err => {
                        this.$notify({
                            title: 'Erreur',
                            message: err.message,
                            type: 'error'
                        });
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss">
.motor-details{
    .form-detail-field {
        position: relative;
        .form-detail-info {
            position: absolute;
            top: 0;
            right: 0;
        }

    }
    .large-text{
        margin-bottom: 15px;
    }
    .large-text ~ .el-form-item__error {
        top: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Selection/MotorDetails.vue